<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title> Block Student Result </v-toolbar-title>
            </v-toolbar>
            <br />

            <v-row dense>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete
                        rounded
                        class="ay-css"
                        :items="academic_year_list"
                        v-model="selected_ay"
                        item-text="academicyear"
                        item-value="ay_id"
                        label="Academic Year"
                        dense
                        color="#0f2027"
                        outlined
                        placeholder="Select Academic Year"
                        :loading="comp_load"
                        @change="celareSelection()"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="9" md="9">
                    <v-row dense>
                        <v-col cols="12" sm="5" md="5">
                            <v-autocomplete
                                rounded
                                multiple
                                :items="stud_list"
                                v-model="stud_data"
                                item-text="name"
                                label="Search Student"
                                dense
                                color="#0f2027"
                                item-value="lid"
                                outlined
                                :loading="comp_load"
                                placeholder="Search by PRN No or name"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2" sm="2" v-if="stud_data != '' && selected_ay != null">
                            <v-btn color="#0f2027" class="button" @click="getData()">Proceed</v-btn>
                        </v-col>
                    </v-row>
                    <v-row dense v-if="selected_ay">
                        <v-col cols="12" md="5" sm="5">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
                        </v-col>
                        <v-btn color="#0f2027" v-if="status" :loading="loader" class="button" @click="getBlockData()">Fetch Block Students</v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <!-- <v-row>
        <v-col cols="12" sm="3" md="3">
          <v-autocomplete
            rounded
            :items="academic_year_list"
            v-model="selected_ay"
            item-text="academicyear"
            item-value="ay_id"
            label="Academic Year"
            dense
            color="#0f2027"
            outlined
            placeholder="Select Academic Year"
            :loading="comp_load"
            @change="celareSelection()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="5" md="5">
          <v-autocomplete
            rounded
            multiple
            :items="stud_list"
            v-model="stud_data"
            item-text="name"
            label="Search Student"
            dense
            color="#0f2027"
            item-value="lid"
            outlined
            :loading="comp_load"
            placeholder="Search by PRN No or name"
          ></v-autocomplete>
        </v-col>
        <v-col
          cols="12"
          md="2"
          sm="2"
          v-if="stud_data != '' && selected_ay != null"
        >
          <v-btn color="#0f2027" class="button" @click="getData()"
            >Proceed</v-btn
          >
        </v-col>
      </v-row>
      <v-row dense v-if="selected_ay">
        <v-col cols="12" md="3" sm="3">
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="status"
            :items="status_list"
            item-text="name"
            item-value="id"
            label="Status"
            outlined
            persistent-hint
            hint="Select Status"
          />
        </v-col>
        <v-btn
          color="#0f2027"
          v-if="status"
          :loading="loader"
          class="button"
          @click="getBlockData()"
          >Fetch Block Students</v-btn
        >
        <v-btn
          color="#0f2027"
          v-if="basic_student_data.length != 0"
          :loading="loader"
          class="button"
          @click="saveData()"
          >Save</v-btn
        >
      </v-row> -->
            <v-toolbar v-if="basic_student_data != ''" flat dense class="toolbar">
                <v-toolbar-title>Student List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <br />

            <v-data-table :headers="headers" :items="basic_info_data_faillist" :search="search" class="elevation-1 mytable" dense v-if="basic_info_data_faillist != ''"> </v-data-table>

            <v-data-table :headers="headers1" :items="basic_student_data" :search="search" class="elevation-1 mytable" dense v-if="basic_student_data != ''">
                <template v-slot:item.result_block="{ item }">
                    <v-switch v-model="item.result_block"></v-switch>
                </template>
            </v-data-table>
            <center> <v-btn color="#0f2027" v-if="basic_student_data != ''" :loading="loader" class="button" @click="saveData()">Save</v-btn></center>
            <!-- <v-row justify="center" dense v-if="selected_ay">
        <v-col cols="12" md="2" sm="2">
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="status"
            :items="status_list"
            item-text="name"
            item-value="id"
            label="Status"
            outlined
            persistent-hint
            hint="Select Status"
          />
        </v-col>
        <v-btn
          color="#0f2027"
          v-if="status"
          :loading="loader"
          class="button"
          @click="getBlockData()"
          >Fetch Block Students</v-btn
        >
        <v-btn
          color="#0f2027"
          v-if="basic_student_data.length != 0"
          :loading="loader"
          class="button"
          @click="saveData()"
          >Save</v-btn
        >
      </v-row> -->
            <br />
            <v-toolbar v-if="block_student_list.length != 0" flat dense class="toolbar">
                <v-toolbar-title>Block Student list</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <!-- <br /> -->
            <v-col cols="12" sm="2" md="2" v-if="block_student_list.length != 0">
                <v-btn color="success" outlined rounded>
                    <download-excel class="mr-2 pb-3 pt-2" :data="block_student_list" :fields="table_fields_block_headers" worksheet="BlockResult" name="BlockResult.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                </v-btn>
            </v-col>
            <v-data-table :headers="block_headers" :items="block_student_list" :search="search" class="elevation-1 mytable" dense v-if="block_student_list.length != 0"> </v-data-table>
            <!-- {{basic_info_data_faillist}}----------{{basic_student_data}} -->
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import CountryMasterVue from "../Admission/AdmissionMaster/CountryMaster.vue";
    export default {
        data: () => ({
            search: "",
            comp_load: false,
            loader: false,
            confirm_dialog: false,
            stud_list: [],
            stud_data: [],
            academic_year_list: null,
            selected_ay: null,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            basic_info_data_faillist: [],
            basic_student_data: [],
            block_student_list: [],
            status_list: [
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],
            status: null,
            headers: [
                { text: "PRN No.", value: "learner", align: "center" },
                { text: "Reason", value: "reason" },
            ],
            block_headers: [
                { text: "PRN No.", value: "reg_no" },
                { text: "Roll No.", value: "stud_rollno" },
                { text: "Name", value: "stud_name" },
                { text: "Standard", value: "stud_std" },
                { text: "Division", value: "stud_div" },
                { text: "Total", value: "total_amount" },
                { text: "Paid", value: "total_paid" },
                { text: "Balance", value: "balance" },
            ],
            table_fields_block_headers: {
                "PRN No.": "reg_no",
                "Roll No.": "stud_rollno",
                Name: "stud_name",
                Standard: "stud_std",
                Division: "stud_div",
                Total: "total_amount",
                Paid: "total_paid",
                Balance: "balance",
            },
            headers1: [
                { text: "PRN No.", value: "registration_number" },
                { text: "Roll No.", value: "roll_no" },
                { text: "Name", value: "student_name" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Block Result", value: "result_block" },
            ],
        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.academic_year_list = res.data.academic_year_list;
                        this.selected_ay = res.data.current_ay;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            getBlockData() {
                this.$vuetify.goTo(9999); // for scrolling down

                const data = {
                    status: this.status,
                    ay: this.selected_ay,
                };
                this.loader = true;
                axios
                    .post("/Examination/getBlockData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.block_student_list = res.data.block_student_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            saveData() {
                this.loader = true;
                const formData = {
                    basic_student_data: this.basic_student_data,
                };
                axios
                    .post("/Examination/saveBlockResult", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.showSnackbar("#4caf50", "Save successfully");
                            this.getData();
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            clearAmount() {
                this.getData();
                this.confirm_dialog = false;
            },
            getData() {
                const formData = {
                    learner_id: this.stud_data,
                    ay_id: this.selected_ay,
                };
                axios
                    .post("/Examination/blockResult", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.basic_info_data_faillist = res.data.basic_info_data_faillist;
                            this.basic_student_data = res.data.basic_student_data;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            celareSelection() {
                this.stud_data = null;
            },
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }
    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .ay-css {
        margin-top: 15%;
    }
</style>
